/*
 * Rennsieger — DRL story page.
 *
 * Builds the one tri-function sticky from the entry context. The product-page
 * teaser links here with ?name=&model=&url=<product url>; arriving that way, the
 * bar offers back-to-product / browse-model / all-DRL. Arriving standalone (menu or
 * footer, no params) it collapses to a single "Shop all DRL". Also runs the reveal
 * animation. No dependencies; no-ops when its markup is absent.
 */
(function () {
  'use strict';

  var root = document.querySelector('[data-rsg-ds]');
  if (!root) return;

  var iBack = '<path d="M15 18l-6-6 6-6"/>';
  var iCar = '<path d="M5 13l1.5-4.5A2 2 0 0 1 8.4 7h7.2a2 2 0 0 1 1.9 1.5L19 13"/><path d="M4 13h16v4H4z"/><circle cx="7.5" cy="17.5" r="1.5"/><circle cx="16.5" cy="17.5" r="1.5"/>';
  var iGrid = '<rect x="3" y="3" width="7" height="7" rx="1"/><rect x="14" y="3" width="7" height="7" rx="1"/><rect x="3" y="14" width="7" height="7" rx="1"/><rect x="14" y="14" width="7" height="7" rx="1"/>';

  function esc(s) {
    return String(s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }
  function sfn(cls, tag, label, icon, href) {
    return '<a class="rsg-ds-sfn ' + cls + '" href="' + esc(href) + '">' +
      '<svg viewBox="0 0 24 24" aria-hidden="true">' + icon + '</svg>' +
      '<span class="lbl"><span class="tag">' + esc(tag) + '</span>' + esc(label) + '</span></a>';
  }

  function buildSticky() {
    var host = root.parentNode.querySelector('[data-rsg-ds-sticky-in]') ||
               document.querySelector('[data-rsg-ds-sticky-in]');
    if (!host) return;

    var params = new URLSearchParams(location.search);
    var allUrl = root.getAttribute('data-all-url') || '/collections/drl';
    var name = params.get('name');
    var model = params.get('model') || '';
    var coll = params.get('coll');

    if (name) {
      // Opened from a product: two options — back to that model's DRL, and all DRL.
      var modelLabel = model ? model + ' DRL' : 'DRL';
      host.innerHTML =
        sfn('is-primary', 'Back to', modelLabel, iCar, coll || allUrl) +
        sfn('', 'See', 'All DRL', iGrid, allUrl);
    } else {
      // Opened standalone (menu / footer): one action.
      host.innerHTML =
        sfn('is-primary', 'Shop', 'All DRL', iGrid, allUrl);
    }
  }

  function initReveal() {
    var els = Array.prototype.slice.call(root.querySelectorAll('.rsg-reveal'));
    if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      var obs = new IntersectionObserver(function (en) {
        en.forEach(function (e) {
          if (e.isIntersecting) { e.target.classList.add('rsg-in'); obs.unobserve(e.target); }
        });
      }, { threshold: 0.08 });
      els.forEach(function (el) { obs.observe(el); });
    } else {
      els.forEach(function (el) { el.classList.add('rsg-in'); });
    }
  }

  /* ---------------- VIN check modal ----------------
   * Same behaviour as the product page: submits through Shopify's contact form so a
   * VIN lands in the store inbox as an ordinary inquiry, AJAX so the modal keeps its
   * own success state. Document-scoped since the standalone story carries its own.
   */
  function initVin() {
    var modal = document.querySelector('[data-rsg-vin]');
    if (!modal) return;
    if (modal.parentElement !== document.body) document.body.appendChild(modal);

    var input = modal.querySelector('[data-rsg-vin-input]');
    var emailEl = modal.querySelector('[data-rsg-vin-email]');
    var form = modal.querySelector('#rsg-ds-vin-contact');
    var wrap = modal.querySelector('[data-rsg-vin-form-wrap]');
    var success = modal.querySelector('[data-rsg-vin-success]');
    var submit = modal.querySelector('[data-rsg-vin-submit]');
    var errEl = modal.querySelector('[data-rsg-vin-err]');
    var lastFocus = null;

    function open(trigger) {
      lastFocus = trigger || document.activeElement;
      if (wrap) wrap.hidden = false;
      if (success) success.hidden = true;
      if (errEl) errEl.textContent = '';
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      setTimeout(function () { if (input) input.focus(); }, 60);
    }
    function close() {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus();
    }

    if (input) input.addEventListener('input', function () {
      input.value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '');
    });

    document.querySelectorAll('[data-rsg-vin-open]').forEach(function (b) {
      b.addEventListener('click', function () { open(b); });
    });
    modal.querySelectorAll('[data-rsg-vin-close]').forEach(function (b) {
      b.addEventListener('click', close);
    });
    modal.addEventListener('click', function (e) {
      if (e.target === modal || e.target.classList.contains('rsg-vin__scrim')) close();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
    });

    if (form) form.addEventListener('submit', function (e) {
      e.preventDefault();
      if (errEl) errEl.textContent = '';
      var email = emailEl ? (emailEl.value || '').trim() : '';
      if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) {
        if (errEl) errEl.textContent = 'Please enter a valid email so we can send your result.';
        if (emailEl) emailEl.focus();
        return;
      }
      var vin = (input.value || '').trim();
      if (vin.length < 11) {
        if (errEl) errEl.textContent = "That doesn't look like a full VIN. It should be 17 characters.";
        input.focus();
        return;
      }
      submit.disabled = true;
      submit.textContent = 'Sending…';
      fetch(form.getAttribute('action') || window.location.pathname, {
        method: 'POST',
        body: new FormData(form),
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      }).then(function () {
        if (wrap) wrap.hidden = true;
        if (success) success.hidden = false;
        setTimeout(close, 2400);
      }).catch(function () {
        submit.disabled = false;
        submit.textContent = 'Check my fit →';
        if (errEl) errEl.textContent = 'Could not send just now. Please try again, or DM us.';
      });
    });
  }

  function boot() {
    buildSticky();
    initReveal();
    initVin();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }
})();
